import { useMemo, useCallback } from "react";
import ItemsList from "template-store/components/items-list/items-list-component";

const ViewsComponent = ({ templateData, metadata }) => {
  const { views } = templateData;

  const getViewsMetadata = useCallback(
    (view) => {
      return metadata?.find((viewMetadata) => viewMetadata.type === view);
    },
    [metadata]
  );

  const viewsData = useMemo(() => {
    if (!views) return;

    return views.map((view) => {
      const viewMetadata = getViewsMetadata(view);
      if (!viewMetadata) return null;
      return {
        title: viewMetadata.title,
        description: viewMetadata.description,
        icon: `https://dapulse-res.cloudinary.com/image/upload/mondayhomepage/template-store/views/${view}.svg`
      };
    });
  }, [getViewsMetadata, views]);

  return <ItemsList items={viewsData} direction="column" />;
};

export default ViewsComponent;
